import styled from 'styled-components';

const OffsetBottom = styled.div`
  position: relative;
`;

export default {
  OffsetBottom,
};
